import { Options } from "common";
import api from "app/api";
import { BlockItem } from "components/FormEditor/types";

/*export type WaiverItem = {
  document: string[];
  fields: WaiverRowItem[];
};*/

export enum WaiverStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}
export type WaiverType = "file" | "builder";

export type WaiverListItem = {
  id: number;
  name: string;
  description: string;
  status: string;
  type: WaiverType;
  file?: { file_name: string; url: string, file_id: string | null; };
  fields: BlockItem[];
};
export type WaiverFormItem = {} & WaiverListItem;

export type WaiverOptions = Options<"group" | "status" | "role">;

function cleanValues(item: WaiverFormItem) {
  return {
    ...item,
    fields: item.fields.map(block => ({
      ...block,
      rows: block.rows.map(row => ({
        ...row,
        fields: row.fields.map(field => ({
          ...field,
          value: field.readonly ? field.value : null,
        })),
      })),
    })),
  };
}

export function getWaiverService() {
  return api.getService<WaiverFormItem, WaiverListItem, WaiverOptions>(
    "waivers",
    {
      itemExporter: item => {
        return {WaiverForm: cleanValues(item)};
      },
    }
  );
}

export function loadWaiverById(id?: string | number) {
  return api.get(`/waivers/${id}`);
}

export function getWaiverLimit() {
  return api.get(`/waivers/limit`);
}

export function copyWaiverById(id?: string | number) {
  return api.post(`/waivers/copy?id=${id}`);
}

export function updateWaiverStatus(id: string | number, status: WaiverStatus, confirm: boolean) {
  return api.post(`/waivers/status?id=${id}`, {
    WaiverStatusChangeForm: {
      status,
      confirm,
    }
  });
}